import React from 'react';
import EducatorLayout from './components/EducatorLayout';
import RecordingsPage from '../shared/RecordingsPage';

const EducatorRecordings = () => (
  <RecordingsPage
    LayoutComponent={EducatorLayout}
    title="Session Recordings"
    description="Review completed sessions and access their recordings."
  />
);

export default EducatorRecordings;
